<div class="body-top">
    <div class="header-bottom pb-5 border-light-bottom" [formGroup]="alertvarservice.ruleForm">
        <div class="query border-light mt-7">
            <div class="query-top px-3">
                <p class=" query-title primary-text primary-bg bold-text content-l px-1">{{alertvarservice.ruleTitles.define_rule_condition}}</p>
                <!-- <div class="time">
                    <div class="timeframe bold-text border-light px-3 pt-3 primary-bg">
                        <p class=" subtitle light-text m-0 primary-bg px-2 content-s">TimeFrame</p>
                        <app-overlay-select fontsize="content-m lighter-text" overlaycontainer="border-none" formControlName="timeframe" [data]="alertvarservice.timeframe" >
                                </app-overlay-select>
                    </div>
                    <p class="content-l bolder-text">+</p>
                    <div class="stepsize bold-text border-light px-3 pt-3 primary-bg">
                        <p class="subtitle light-text m-0 primary-bg px-2 content-s">StepSize</p>
                        <app-overlay-select fontsize="content-m lighter-text" overlaycontainer="border-none" formControlName="stepsize" [data]="alertvarservice.stepsize">
                        </app-overlay-select>
                    </div>
                </div> -->
            </div>
            <div class="editor my-7">
                <alert-query-editor [builtInquery]="query.getRawValue()" [readonly]="readonly" [alertId]="alertId"
                (changedQuery)="conditionfromeditor($event)"> </alert-query-editor>
            </div>
            
        </div>
        <div class="test pt-5">
            <p class="selectable-text content-m enable-action" (click)="verifyquery()">{{alertvarservice.ruleTitles.run_tests}}</p>
            <div *ngIf="alertvarservice.showError" class="alert-text content-s">{{alertvarservice.errorTypes.query_error}}</div>
        </div>
        <div class="test-results">
            <ng-container *ngIf="alertvarservice.testResultVolume">
                <div class="labels">
                    <p class="primary-text content-m">{{alertvarservice.ruleTitles.alert_test_volume}}</p>                
                    <p class="primary-text content-m">{{alertvarservice.ruleTitles.auto_actionable_alerts}}</p>
                    <p class="primary-text content-m">{{alertvarservice.ruleTitles.effective_noise_reduction}}</p>
                </div>
                <div class="colon">
                    <p *ngFor="let p of [1,2,3]" class="primary-text content-m">:</p>
                </div>
                <div class="results">
                    <p class="selectable-text content-m">{{alertvarservice.testResultVolume}} {{alertsLabel}}</p>
                    <p class="selectable-text content-m">{{testResultActionable}} {{alertsLabel}}</p>
                    <p class="selectable-text content-m">{{testResultNoise}} {{percentLabel}}</p>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="body-bottom mt-5" [formGroup]="alertvarservice.ruleForm">
    <div class="titles">
        <h4 class="primary-text bold-text">{{alertvarservice.ruleTitles.closure_action}}</h4>
        <div *ngIf="alertvarservice.showActionError" class="alert-text content-s">{{alertvarservice.errorTypes.action_error}} </div>
    </div>
    <div class="action-list-1 border-light-bottom pb-5">
        <ng-container *ngIf="alertvarservice.mockClosureAction.status | keyvalue:originalOrder as action">
            
                <div class="action-sub-list">
                    <ng-container *ngFor="let list of action ">
                        <ng-container *ngIf="list.key !=0">
                            <ng-container *ngIf="list.value['disp']">
                                <div class="reviewlist pt-4 pr-4 pl-2" >
                                    <div class="title secondary-text my-2 mr-2 px-4 pt-1 radius-xl" [ngClass]="list.key == alertvarservice.clickedAction ? 'chips-active':'chips-default'" (click)="actionclick(list.key)">
                                        <p class="content-l primary-text enable-action" [ngClass]="list.value['disp']=='New'?'':''">{{list.value['disp']}}</p>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
        
                <ng-container *ngIf="alertvarservice.clickedAction">
                    <div class="action-bottom">
                        <div class="action-bottom-left">
                            <ng-container *ngFor="let state of alertvarservice.mockClosureAction.status[alertvarservice.clickedAction]?.state | keyvalue:originalOrder">
                                <p class="content-m primary-text enable-action" (click)="catClick(state.key)" [ngClass]="state.key===alertvarservice.clickedState ? 'selectable-text' : 'primary-text'">{{state.value['disp']}}</p>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="alertvarservice.clickedState != '' ">
                            <div class="action-bottom-right border-light-left pl-5">
                                <ng-container *ngFor="let cat of alertvarservice.mockClosureAction?.status[alertvarservice.clickedAction]?.state[alertvarservice.clickedState]?.category | keyvalue:originalOrder">
                                    <p class="content-m primary-text enable-action" (click)="reasonClick(cat.key)" [ngClass]="cat.key===alertvarservice.clickedReason ? 'selectable-text' : 'primary-text'">{{cat.value['disp']}}</p>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="alertvarservice.clickedReason != '' ">
                            <div class="action-bottom-right-2 border-light-left pl-5">
                                <ng-container *ngFor="let res of alertvarservice.mockClosureAction?.status[alertvarservice.clickedAction]?.state[alertvarservice.clickedState]?.category[alertvarservice.clickedReason]?.reason | keyvalue:originalOrder">
                                    <ng-container *ngIf="res.key != 9999">
                                        <p class="content-m primary-text enable-action" (click)="stateReasonClick(res.key)" [ngClass]="res.key===alertvarservice.clickedStateReason  ? 'selectable-text' : 'primary-text'">{{res.value['disp']}}</p>
                                    </ng-container>
                                    <ng-container *ngIf="res.key == 9999">
                                        <p class="content-m primary-text enable-action" (click)="stateReasonClick(res.key)" [ngClass]=" res.key===alertvarservice.clickedStateReason  ? 'selectable-text' : 'primary-text'">{{res.value['disp']}}</p>
                                    </ng-container>
                                </ng-container>
                                <!-- <p class="content-l primary-text enable-action" (click)="commentsClick()" [ngClass]=" alertvarservice.openComments === true  ? 'selectable-text' : 'primary-text'">Others</p> -->
                                <!-- <ng-container *ngIf="alertvarservice.openComments"> -->
                                    <div class="comments" [ngClass]="alertvarservice.clickedStateReason == '9999' ? '' :'hide'">
                                        <h5 class="bold-text primary-text">{{alertvarservice.ruleTitles.comments}}</h5>
                                        <textarea class="input-border border-light primary-bg" type="text" formControlName="comments"></textarea>
                                    </div>
                                <!-- </ng-container> -->
                            </div>
                        </ng-container>
                        <!-- <ng-container *ngIf="alertvarservice.openComments">
                            <div class="comments border-light-left pl-8">
                                <h4 class="bold-text primary-text">{{alertvarservice.ruleTitles.comments}}</h4>
                                <textarea class="input-border border-light primary-bg" type="text" formControlName="comments"></textarea>
                            </div>
                        </ng-container> -->
                    </div>
                </ng-container>
        </ng-container>
    </div>
    <div class="action" formGroupName="actions">
        <div class="action-left  primary-bg ">

            <!-- <ng-container *ngIf="alertvarservice.closureAction1 | keyvalue:originalOrder as action">
                <div class="action-list">
                    <ng-container *ngFor="let list of action ">
                        <ng-container *ngIf="list.value['disp']">
                            <div class="reviewlist pt-4 pr-4 pl-2" [ngClass]="[list.value.enable ? '':'disable-action',list.key === alertvarservice.actionWindow ?'white-bg selected-list':'primary-bg']" >
                                <div class="title">
                                    <ng-container *ngIf="!list.value.state">
                                        <img class="icon-s default-icon"  src="../../../assets/rule/greenTick.svg">
                                    </ng-container>
                                    <ng-container *ngIf="list.value.state">
                                        <img class="icon-s" [ngClass]="list.value.state === -1 ?'error-icon':''" src="../../../assets/rule/greenTick.svg">
                                    </ng-container>
                                    <p class="content-l primary-text">{{list.value['disp']}}</p>
                                </div>
                                <div class="state-action pl-10">
                                    <ng-container *ngFor="let state of list.value['state_action'] | keyvalue" >
                                        <div class="state">
                                            <p class="content-m enable-action" [ngClass]="statename.value === state.key && actionname.value===list.key  ? 'selectable-text':'primary-text'" (click)="changeStateAction(list.key,state.key,$event)" >{{state.value.disp}}</p>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container> -->

            <ng-container *ngIf="alertvarservice.closureAction | keyvalue:originalOrder as action">
                <div class="action-list border-light-right">
                    <ng-container *ngFor="let list of action ">
                        <ng-container *ngIf="list.value['disp']">
                            <div class="list py-4 pr-4 pl-2" [ngClass]="[list.value.enable ? '':'disable-action',list.key === alertvarservice.actionWindow ?'white-bg selected-list':'primary-bg']" (click)="changeAction(list.key,$event)">
                                <ng-container *ngIf="!list.value.state">
                                    <img class="icon-s default-icon"  src="../../../assets/rule/greenTick.svg">
                                </ng-container>
                                <ng-container *ngIf="list.value.state">
                                    <img class="icon-s" [ngClass]="list.value.state === -1 ?'error-icon':''" src="../../../assets/rule/greenTick.svg">
                                </ng-container>
                                <p class="content-l primary-text enable-action">{{list.value['disp']}}</p>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div class="action-right">
            <ng-container *ngIf="alertvarservice.actionWindow==='add_tags'">
                <div class="row-4" >
                    <div class="tab-1-bottom-left-row-2 pt-2">
                        <p class="content-l bold-text label-text">Tags</p>
                        <div class="tags-chip-container" #tagorigin2>
                            <div class="tags-chip-input">
                                <div class='tag-autocomplete content-l m-0'>
                                    <input class="input-m input is-medium input-border primary-bg" #moreOrigin
                                        [placeholder]="alertvarservice.ruleTitles.choose_tags"
                                        [tagAutocomplete]="[tagdirective,tagorigin2]"
                                        [formControl]="tagsSearchcontrol">
                                </div>
                                <tag-autocomplete #tagdirective="tagautocomplete">
                                    <ng-template tagAutocompleteContent formGroupName="add_tags">
                                        <ng-container formGroupName="tags">
                                            <ng-container *ngFor="let group of alertvarservice.distag|keyvalue;let i=index">
                                                <tag-option-group *ngIf="group.value.length > 0"
                                                    [label]="alertvarservice.commondata.tags.mapping[group.key]"
                                                    [formGroupName]="group.key">
                                                    <tag-option class="pl-6" *ngFor="let option of group.value"
                                                        [value]="option.disp" class="autocomplete-option span-m">
                                                        <label> <input class="border-none shadow-none" type="checkbox" 
                                                                [formControlName]="option.val"> <span class="p-4">{{ option.disp}}
                                                                </span></label>
                                                    </tag-option>
                                                </tag-option-group>
                                            </ng-container>
                                            <!-- <tag-option class="no-result span-m pl-6" *ngIf="!optionsGroup.length">
                                                <span class="p-4"></span>
                                            </tag-option> -->
                                        </ng-container>
                                    </ng-template>
                                </tag-autocomplete>
                            </div>
                        </div>
                        <!-- <div class="tag-chip-list content-m mt-6" *ngIf="alertvarservice.tagsSet.size != 0">
                            <ng-container *ngFor="let tag1 of 7| limitset: alertvarservice.tagsSet:alertvarservice.tagsSet.size; let j = index">
                                <div class="tag-chip secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report">
                                    <span class="span-m px-2 enable-action">{{tag1.parent}} : {{tag1.disp}}</span>
                                    <img class="pr-1" src="assets/rule/close-dialog.svg" (click)="removetagChip_click(tag1)">
                                </div>
                            </ng-container>
                            <div class="more-chip secondary-text content-m my-2 mr-2 px-4 pt-1 radius-xl border-report" *ngIf="alertvarservice.tagsSet.size > 7">
                                <span class="span-m px-2" #moreTags >+{{alertvarservice.tagsSet.size -7}} more</span>
                            </div>
                        </div> -->
                        <div class="tag-chip-list content-m mt-6" >
                            <ng-container *ngFor="let tagged of alertvarservice.ruleForm.value?.actions?.add_tags.tags  | keyvalue">
                            <ng-container *ngFor="let tag of alertvarservice.ruleForm.value?.actions?.add_tags.tags[tagged.key]  | keyvalue">
                                <!-- <ng-container *ngFor="let list of tag.value | keyValue"> -->
                                    <ng-container *ngIf="tag.value">
                                    
                                        <div class="tag-chip secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report">
                                            
                                                <span class="span-m px-2">{{tagged.key}} : {{tag.key}}</span>

                                                <img class="pr-1" src="assets/rule/close-dialog.svg" (click)="removeChipAlert(tag.key, tagged.key)">
                             
                                        </div>
                                    <!-- </ng-container> -->
                                </ng-container>

                            </ng-container>
                            </ng-container>
                            <div class="more-chip secondary-text content-m my-2 mr-2 px-4 pt-1 radius-xl border-report" *ngIf="alertvarservice.tagsSet.size > 7">
                                <span class="span-m px-2" #moreTags >+{{alertvarservice.tagsSet.size -7}} more</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- <ng-container *ngIf="alertvarservice.closureAction1[alertvarservice.actionWindow]">
                <div class="state-container">
                    <ng-container *ngIf="alertvarservice.closureAction1[alertvarservice.actionWindow].state_action[alertvarservice.stateWindow]">
                        <div class="reasons-container pt-9 mr-5">
                            <ng-container *ngFor="let list of alertvarservice.closureAction1[alertvarservice.actionWindow].state_action[alertvarservice.stateWindow].reason | keyvalue">
                                <div class="reasons">
                                    <p class="content-m enable-action" [ngClass]="closurereason.value === list.key && statename.value===alertvarservice.stateWindow && actionname.value===alertvarservice.actionWindow ? 'selectable-text':'primary-text'" (click)="stateClick(alertvarservice.actionWindow,alertvarservice.stateWindow,list.key)">{{list.value}}</p>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <div class="comments">
                        <h4 class="bold-text primary-text">{{alertvarservice.ruleTitles.comments}}</h4>
                        <textarea class="input-border border-light primary-bg" type="text" formControlName="comments"></textarea>
                    </div>
                </div>
            </ng-container> -->


            <!-- <ng-container *ngIf="alertvarservice.actionWindow==='close'">
                <div class="state-container">
                    <ng-container *ngIf="statename.value==='Benign true positive'">
                        <div class="reasons-container pt-9 ">
                            <ng-container *ngFor="let list of alertvarservice.closureAction1.close.state_action[alertvarservice.stateWindow].reason | keyvalue">
                                <div class="reasons">
                                    <p class="content-m enable-action" [ngClass]="closurereason.value === list.value ? 'selectable-text':'primary-text'" (click)="stateClick(alertvarservice.actionWindow,alertvarservice.stateWindow,list.value)">{{list.value}}</p>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="statename.value==='False positive'">
                        <div class="reasons-container pt-9 border-light-right">
                            <ng-container *ngFor="let list of alertvarservice.closureAction1.close.state_action[alertvarservice.stateWindow].reason | keyvalue">
                                <div class="reasons">
                                    <p class="content-m enable-action" [ngClass]="closurereason.value === list.value ? 'selectable-text':'primary-text'" (click)="stateClick(alertvarservice.actionWindow,alertvarservice.stateWindow,list.value)">{{list.value}}</p>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="statename.value==='Undetermined'">
                        <div class="reasons-container pt-9 border-light-right">
                            <ng-container *ngFor="let list of alertvarservice.closureAction1.close.state_action[alertvarservice.stateWindow].reason | keyvalue">
                                <div class="reasons">
                                    <p class="content-m enable-action" [ngClass]="closurereason.value === list.value ? 'selectable-text':'primary-text'" (click)="stateClick(alertvarservice.actionWindow,alertvarservice.stateWindow,list.value)">{{list.value}}</p>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                        <div class="comments" >
                            <h4 class="bold-text primary-text">{{alertvarservice.ruleTitles.comments}}</h4>
                            <textarea class="input-border border-light primary-bg" type="text" formControlName="comments"></textarea>
                        </div>
                </div>
            </ng-container> -->
        </div>
    </div>
</div>
